module.exports = __webpack_public_path__ + "img/caratula_bambu_blurred.48499eaf.jpeg";